<div class="paragraph">
  <p class="paragraph_title">
    {{ 'MyProfile_AS_Password' | translate }}
  </p>
  <div class="paragraph_instruction">
    <div class="paragraph_instruction_message" [innerHTML]=" 'MyProfile_AS_PasswordErorMessage' | translate " >
    </div>
    <div [innerHTML]=" 'MyProfile_AS_BackPasswordErorMessage' | translate ">
    </div>
  </div>
</div>
<div>
  <form [formGroup]="formGroup">
    <div class="password_area">
      <div class="form-group">
        <label for="password">{{ 'MyProfile_AS_ChoosePassword' | translate }}</label>
        <div class="password_area_password_field">
          <input
            #passwordElement
            id="password"
            type="password"
            formControlName="password"
            class="form-control"
            [class.password_area_password_field_password_open]="isDisplayed"
            (ngModelChange)="passwordUpdated()"
          />
          <span class="password_area_password_field_eye_field" (click)="onShowPasswordIconClick()">
            <i [ngClass]="isDisplayed ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
          </span>
        </div>
        <div *ngIf="password?.errors?.currentPasswordValidationError" class="password_area_error_message">
          {{ 'MyProfile_AS_BackPasswordErorMessage' | translate }}
        </div>
      </div>
      <div class="password_area_pointer"></div>
      <div class="password_area_password_criteria">
        <p class="password_area_password_criteria_title">{{ 'MyProfile_AS_PasswordRequirements' | translate }}</p>
        <label class="col" [class.valid_password_case]="!isInValidPasswordLength()">
          <i
            [ngClass]="
              isInValidPasswordLength()
                ? 'far fa-square password_area_password_criteria_not_valid'
                : 'fas fa-check password_area_password_criteria_valid'
            "
          ></i>
          {{ 'MyProfile_AS_EightOrMore' | translate }}
        </label>
        <hr />
        <label class="col password_area_password_criteria_title">
          <i
            [ngClass]="
              !isFollowCriteriasValid
                ? 'far fa-square password_area_password_criteria_not_valid'
                : 'fas fa-check password_area_password_criteria_valid'
            "
          ></i
          >{{ 'MyProfile_AS_ThirdPasswordCriteria' | translate }}
        </label>
        <label class="col password_area_password_criteria_item">
          <div class="password_area_password_criteria_progress">
            <div
              class="password_area_password_criteria_progress_discrete_left"
              [class.valid_password_discrete]="isPasswordDicreteValid(1)"
            ></div>
            <div
              class="password_area_password_criteria_progress_discrete"
              [class.valid_password_discrete]="isPasswordDicreteValid(2)"
            ></div>
            <div
              class="password_area_password_criteria_progress_discrete_right"
              [class.valid_password_discrete]="isPasswordDicreteValid(3)"
            ></div>
          </div>
        </label>
        <label class="col password_area_password_criteria_item" [class.valid_password_case]="isValidCase('UpperCase')">
          {{ 'MyProfile_AS_UpperCase' | translate }}
        </label>
        <label class="col password_area_password_criteria_item" [class.valid_password_case]="isValidCase('LowerCase')">
          {{ 'MyProfile_AS_LowerCase' | translate }}
        </label>
        <label class="col password_area_password_criteria_item" [class.valid_password_case]="isValidCase('Number')">
          {{ 'MyProfile_AS_Number' | translate }}
        </label>
        <label
          class="col password_area_password_criteria_item"
          [class.valid_password_case]="isValidCase('SpecialSymbol')"
        >
          {{ 'MyProfile_AS_Symbol' | translate }}
        </label>
      </div>
    </div>
  </form>
</div>
